import { getHardwareIdentity } from '@upshow/brightsign/src';

// BrightSign OS version from the native SDK. Cached once found; a missing value is retried at
// most once a minute, since getDeviceInfo() runs on every payload.
const RETRY_MS = 60_000;

let osVersion = null;
let lastAttemptAt = -Infinity;

export function getOsVersion (now = Date.now()) {
    if (osVersion) return osVersion;
    if (now - lastAttemptAt < RETRY_MS) return null;

    lastAttemptAt = now;

    const identity = getHardwareIdentity();
    if (identity?.available && identity.osVersion) osVersion = identity.osVersion;

    return osVersion;
}

export function osVersionFor (model, now) {
    return model === 'BrightSign' ? getOsVersion(now) : undefined;
}

export function resetOsVersion () {
    osVersion = null;
    lastAttemptAt = -Infinity;
}
